import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS


const Hero = () => {
  // Inline styles for black theme
  const heroContainerStyle = {
    backgroundColor: '#000', // Black background
    padding: '100px 0',
    textAlign: 'center',
    color: '#fff', // White text color
    
  };


  const headingStyle = {
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    lineHeight: '1.2',
    color: '#fff', // White text for heading
    animation: 'slideDown 2s ease',
  };
  const headStyle = {
    fontSize: '3rem',
    fontWeight: 'bold',
    marginBottom: '10px',
    lineHeight: '1.2',
    color: '#fff', // White text for heading
    animation: 'slideDown 2s ease',
  };
  const spanPrimaryStyle = {
    color: '#21438E', // Red color for the primary span
  };
  

  const buttonStyle = {
    border: 'none',
    borderRadius: '50px',
    padding: '15px 30px',
    margin: '0 10px',
    fontSize: '1rem',
    fontWeight: 'bold',
    color: '#fff', // White text
    backgroundColor: '#af1831', // Bright red button
    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
  };

  const buttonHoverStyle = {
    transform: 'scale(1.05)',
    boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.2)', // White shadow for hover
  };

  const imageStyle = {
    maxWidth: '100%',
    
    animation: 'zoomIn 2s ease',
     // Subtle white glow around the image
  };

  const keyframes = `
    @keyframes fadeIn {
      from { opacity: 0; }
      to { opacity: 1; }
    }
    @keyframes slideDown {
      from { transform: translateY(-50px); opacity: 0; }
      to { transform: translateY(0); opacity: 1; }
    }
    @keyframes zoomIn {
      from { transform: scale(0.8); opacity: 0; }
      to { transform: scale(1); opacity: 1; }
    }
  `;

  return (
    <div style={heroContainerStyle}>
      {/* Adding keyframes directly to the page */}
      <style>{keyframes}</style>
      <div className="container">
        <div className="row g-4 align-items-center">
          {/* Left Section with Text and Buttons */}
          <div className="col-lg-7 col-md-12">
            <span style={headStyle}>
              Welcome to Everest Momo Cafe
            </span>
            <h1 style={headingStyle}>
              <span style={spanPrimaryStyle}>Asian Tasty Food</span> <br />
              Savor Flavors for Your Perfect Meal
            </h1>
            <div>
              <a
                href="https://wolt.com/en/fin/turku/restaurant/the-momo-cafe"
                className="btn"
                style={buttonStyle}
                onMouseEnter={(e) => Object.assign(e.target.style, buttonHoverStyle)}
                onMouseLeave={(e) => Object.assign(e.target.style, buttonStyle)}
              >
                Order Now
              </a>
            </div>
          </div>

          {/* Right Section with Images */}
          <div className="col-lg-5 col-md-12">
            <img
              src="momo.png"
              alt="Steaming Momos"
              style={imageStyle}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
